import { connect } from "react-redux";
import { passwordReset, password } from "../actions";
import PasswordResetComponent from "../components/password-reset.jsx";

const mapStateToProps = (state) => ({
  errors: state.auth.password_reset.errors,
});

export default connect(
  mapStateToProps,
  {
    password_reset: passwordReset.request,
    password: password.request,
  },
)(PasswordResetComponent);
